import request from '@/util/http'
import qs from 'qs'

// 获取个人信息
export const getPersonalInfo=()=>request({
    url: '/admin/personalCenter/info',
    method: 'get',
})

// 获取用户登录数据
export const getLogData=(params)=>request({
    url: '/admin/log/page',
    method: 'get',
    params
})

// 修改个人信息
export const updatePersonInfo = (data, userId) =>
  request({
    headers: {
      "Content-Type": "application/json",
    },
    url: `/admin/personalCenter/edit/${userId}`,
    method: "post",
    data: data,
  });
// export const updatePersonInfo=(data,userId)=>request({
//     headers:{
//         "Content-Type": "application/json"
//     },
//     url: `/admin/personalCenter/edit/${userId}`,
//     method: 'post',
//     data: data
// })

// 修改密码
export const passwordEdit=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: '/admin/personalCenter/changePassword',
    method: 'post',
    data:JSON.stringify(data)
})
